import { render, staticRenderFns } from "./basicGroup.vue?vue&type=template&id=edcc7dea&scoped=true"
import script from "./basicGroup.vue?vue&type=script&lang=js"
export * from "./basicGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcc7dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edcc7dea')) {
      api.createRecord('edcc7dea', component.options)
    } else {
      api.reload('edcc7dea', component.options)
    }
    module.hot.accept("./basicGroup.vue?vue&type=template&id=edcc7dea&scoped=true", function () {
      api.rerender('edcc7dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsGrouped/basicGroup.vue"
export default component.exports